// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"imzaT":[function(require,module,exports) {
require("ea9b74cca40090cf").register(require("175471d8e22905ce").getBundleURL("gAkDS"), JSON.parse('["gAkDS","index.ea5e85a1.js","hvOsp","jszip.min.56cb75cc.js"]'));

},{"ea9b74cca40090cf":"6oqja","175471d8e22905ce":"hUXv3"}],"6oqja":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"hUXv3":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}],"gLO4P":[function(require,module,exports) {
// eslint-disable-next-line import/no-unassigned-import
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _typedQuerySelector = require("typed-query-selector");
var _listGithubDirContent = require("list-github-dir-content");
var _pMap = require("p-map");
var _pMapDefault = parcelHelpers.interopDefault(_pMap);
var _downloadJs = require("./download.js");
var _repositoryInfoJs = require("./repository-info.js");
function isError(error) {
    return error instanceof Error;
}
function saveFile(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}
async function listFiles(repoListingConfig) {
    const files = await (0, _listGithubDirContent.getDirectoryContentViaTreesApi)(repoListingConfig);
    if (!files.truncated) return files;
    updateStatus('Warning: It\u2019s a large repo and this it take a long while just to download the list of files. You might want to use "git sparse checkout" instead.');
    return (0, _listGithubDirContent.getDirectoryContentViaContentsApi)(repoListingConfig);
}
function updateStatus(status, ...extra) {
    const element = document.querySelector(".status");
    if (status) {
        const wrapper = document.createElement("div");
        wrapper.textContent = status;
        element.prepend(wrapper);
    } else element.textContent = status ?? "";
    console.log(status, ...extra);
}
async function getZip() {
    // @ts-expect-error idk idc
    // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/consistent-type-imports
    const JSZip = await require("3a6084253342d32e");
    return new JSZip();
}
const googleDoesntLikeThis = /malware|virus|trojan/i;
async function init() {
    updateStatus();
    const zipPromise = getZip();
    const input = document.querySelector("input#token");
    const token = localStorage.getItem("token");
    if (token) input.value = token;
    input.addEventListener("input", ()=>{
        localStorage.setItem("token", input.value);
    }, {
        passive: true
    });
    const query = new URLSearchParams(location.search);
    const url = query.get("url");
    document.querySelector("input#url").value = url ?? "";
    if (!url) return;
    if (!navigator.onLine) {
        updateStatus("\u26A0 You are offline.");
        throw new Error("You are offline");
    }
    const repositoryPreview = (0, _repositoryInfoJs.getRepositoryPreview)(url);
    if ("error" in repositoryPreview) {
        if (repositoryPreview.error === "NOT_A_REPOSITORY") updateStatus("\u26A0 Not a repository");
        else if (repositoryPreview.error === "NOT_A_DIRECTORY") updateStatus("\u26A0 Not a directory");
        else updateStatus("\u26A0 Unknown error");
        return;
    }
    updateStatus(`Repo: ${repositoryPreview.user}/${repositoryPreview.repository}`);
    const parsedPath = await (0, _repositoryInfoJs.getRepositoryInfo)(repositoryPreview);
    if ("error" in parsedPath) {
        if (parsedPath.error === "REPOSITORY_NOT_FOUND") updateStatus("\u26A0 Repository not found. If it\u2019s private, you should enter a token that can access it.");
        else updateStatus("\u26A0 Unknown error");
        return;
    }
    const { user, repository, gitReference, directory, isPrivate } = parsedPath;
    updateStatus(`Directory: /${directory}`, {
        source: {
            user,
            repository,
            gitReference,
            directory,
            isPrivate
        }
    });
    if ("downloadUrl" in parsedPath) {
        updateStatus("Downloading the entire repository directly from GitHub");
        window.location.href = parsedPath.downloadUrl;
        return;
    }
    updateStatus("Retrieving directory info");
    let files = await listFiles({
        user,
        repository,
        ref: gitReference,
        directory,
        token: localStorage.getItem("token") ?? undefined,
        getFullData: true
    });
    let foundBlockedFiles = false;
    files = files.filter((file)=>{
        if (googleDoesntLikeThis.test(file.path)) {
            foundBlockedFiles = true;
            updateStatus(`File blocked: ${file.path}`);
            return false;
        }
        return true;
    });
    if (files.length === 0) {
        if (foundBlockedFiles) updateStatus("\u26A0 Some files were blocked due to Google Safe Browsing.");
        updateStatus("No files to download");
        return;
    }
    updateStatus(`Will download ${files.length} files`);
    const controller = new AbortController();
    const signal = controller.signal;
    let downloaded = 0;
    try {
        await (0, _pMapDefault.default)(files, async (file)=>{
            const blob = await (0, _downloadJs.downloadFile)({
                user,
                repository,
                reference: gitReference,
                file,
                isPrivate,
                signal
            });
            downloaded++;
            updateStatus(file.path);
            const zip = await zipPromise;
            zip.file(file.path.replace(directory + "/", ""), blob, {
                binary: true
            });
        }, {
            concurrency: 20
        });
    } catch (error) {
        controller.abort();
        if (!navigator.onLine) updateStatus("\u26A0 Could not download all files, network connection lost.");
        else if (isError(error) && error.message.startsWith("HTTP ")) updateStatus("\u26A0 Could not download all files.");
        else updateStatus("\u26A0 Some files were blocked from downloading, try to disable any ad blockers and refresh the page.");
        throw error;
    }
    updateStatus(`Zipping ${downloaded} files...`);
    const zip = await zipPromise;
    const zipBlob = await zip.generateAsync({
        type: "blob"
    });
    const filename = query.get("filename") ?? `${user} ${repository} ${gitReference} ${directory}`.replace(/\//, "-");
    const zipFilename = filename.endsWith(".zip") ? filename : `${filename}.zip`;
    saveFile(zipBlob, zipFilename);
    if (foundBlockedFiles) updateStatus("\u26A0 Some files were blocked due to Google Safe Browsing.");
    updateStatus(`Downloaded ${downloaded} files! Done!`);
}
// eslint-disable-next-line unicorn/prefer-top-level-await -- Not allowed
init().catch((error)=>{
    if (error instanceof Error) switch(error.message){
        case "Invalid token":
            updateStatus("\u26A0 The token provided is invalid or has been revoked.", {
                token: localStorage.getItem("token")
            });
            break;
        case "Rate limit exceeded":
            updateStatus("\u26A0 Your token rate limit has been exceeded. Please wait or add a token", {
                token: localStorage.getItem("token")
            });
            break;
        default:
            updateStatus(`\u{26A0} ${error.message}`, error);
            break;
    }
});

},{"typed-query-selector":"hyT0C","list-github-dir-content":"9YVya","p-map":"iTAy0","./download.js":"gF7Lk","./repository-info.js":"jufXb","3a6084253342d32e":"3dq3H","@parcel/transformer-js/src/esmodule-helpers.js":"qayoQ"}],"hyT0C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"qayoQ"}],"qayoQ":[function(require,module,exports) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, "__esModule", {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"9YVya":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Great for downloads with few sub directories on big repos
// Cons: many requests if the repo has a lot of nested dirs
parcelHelpers.export(exports, "getDirectoryContentViaContentsApi", ()=>getDirectoryContentViaContentsApi);
// Great for downloads with many sub directories
// Pros: one request + maybe doesn't require token
// Cons: huge on huge repos + may be truncated
parcelHelpers.export(exports, "getDirectoryContentViaTreesApi", ()=>getDirectoryContentViaTreesApi);
async function api(endpoint, token) {
    const response = await fetch(`https://api.github.com/repos/${endpoint}`, {
        headers: token ? {
            Authorization: `Bearer ${token}`
        } : undefined
    });
    return response.json();
}
async function getDirectoryContentViaContentsApi({ user, repository, ref: reference = "HEAD", directory, token, getFullData = false }) {
    const files = [];
    const requests = [];
    const contents = await api(`${user}/${repository}/contents/${directory}?ref=${reference}`, token);
    if (contents.message === "Not Found") return [];
    if (contents.message) throw new Error(contents.message);
    for (const item of contents){
        if (item.type === "file") files.push(getFullData ? item : item.path);
        else if (item.type === "dir") requests.push(getDirectoryContentViaContentsApi({
            user,
            repository,
            ref: reference,
            directory: item.path,
            token,
            getFullData
        }));
    }
    return [
        ...files,
        ...await Promise.all(requests)
    ].flat();
}
async function getDirectoryContentViaTreesApi({ user, repository, ref: reference = "HEAD", directory, token, getFullData = false }) {
    if (!directory.endsWith("/")) directory += "/";
    const files = [];
    const contents = await api(`${user}/${repository}/git/trees/${reference}?recursive=1`, token);
    if (contents.message) throw new Error(contents.message);
    for (const item of contents.tree)if (item.type === "blob" && item.path.startsWith(directory)) files.push(getFullData ? item : item.path);
    files.truncated = contents.truncated;
    return files;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"qayoQ"}],"iTAy0":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pMap);
parcelHelpers.export(exports, "pMapIterable", ()=>pMapIterable);
parcelHelpers.export(exports, "pMapSkip", ()=>pMapSkip);
async function pMap(iterable, mapper, { concurrency = Number.POSITIVE_INFINITY, stopOnError = true, signal } = {}) {
    return new Promise((resolve, reject_)=>{
        if (iterable[Symbol.iterator] === undefined && iterable[Symbol.asyncIterator] === undefined) throw new TypeError(`Expected \`input\` to be either an \`Iterable\` or \`AsyncIterable\`, got (${typeof iterable})`);
        if (typeof mapper !== "function") throw new TypeError("Mapper function is required");
        if (!(Number.isSafeInteger(concurrency) && concurrency >= 1 || concurrency === Number.POSITIVE_INFINITY)) throw new TypeError(`Expected \`concurrency\` to be an integer from 1 and up or \`Infinity\`, got \`${concurrency}\` (${typeof concurrency})`);
        const result = [];
        const errors = [];
        const skippedIndexesMap = new Map();
        let isRejected = false;
        let isResolved = false;
        let isIterableDone = false;
        let resolvingCount = 0;
        let currentIndex = 0;
        const iterator = iterable[Symbol.iterator] === undefined ? iterable[Symbol.asyncIterator]() : iterable[Symbol.iterator]();
        const reject = (reason)=>{
            isRejected = true;
            isResolved = true;
            reject_(reason);
        };
        if (signal) {
            if (signal.aborted) reject(signal.reason);
            signal.addEventListener("abort", ()=>{
                reject(signal.reason);
            });
        }
        const next = async ()=>{
            if (isResolved) return;
            const nextItem = await iterator.next();
            const index = currentIndex;
            currentIndex++;
            // Note: `iterator.next()` can be called many times in parallel.
            // This can cause multiple calls to this `next()` function to
            // receive a `nextItem` with `done === true`.
            // The shutdown logic that rejects/resolves must be protected
            // so it runs only one time as the `skippedIndex` logic is
            // non-idempotent.
            if (nextItem.done) {
                isIterableDone = true;
                if (resolvingCount === 0 && !isResolved) {
                    if (!stopOnError && errors.length > 0) {
                        reject(new AggregateError(errors)); // eslint-disable-line unicorn/error-message
                        return;
                    }
                    isResolved = true;
                    if (skippedIndexesMap.size === 0) {
                        resolve(result);
                        return;
                    }
                    const pureResult = [];
                    // Support multiple `pMapSkip`'s.
                    for (const [index, value] of result.entries()){
                        if (skippedIndexesMap.get(index) === pMapSkip) continue;
                        pureResult.push(value);
                    }
                    resolve(pureResult);
                }
                return;
            }
            resolvingCount++;
            // Intentionally detached
            (async ()=>{
                try {
                    const element = await nextItem.value;
                    if (isResolved) return;
                    const value = await mapper(element, index);
                    // Use Map to stage the index of the element.
                    if (value === pMapSkip) skippedIndexesMap.set(index, value);
                    result[index] = value;
                    resolvingCount--;
                    await next();
                } catch (error) {
                    if (stopOnError) reject(error);
                    else {
                        errors.push(error);
                        resolvingCount--;
                        // In that case we can't really continue regardless of `stopOnError` state
                        // since an iterable is likely to continue throwing after it throws once.
                        // If we continue calling `next()` indefinitely we will likely end up
                        // in an infinite loop of failed iteration.
                        try {
                            await next();
                        } catch (error) {
                            reject(error);
                        }
                    }
                }
            })();
        };
        // Create the concurrent runners in a detached (non-awaited)
        // promise. We need this so we can await the `next()` calls
        // to stop creating runners before hitting the concurrency limit
        // if the iterable has already been marked as done.
        // NOTE: We *must* do this for async iterators otherwise we'll spin up
        // infinite `next()` calls by default and never start the event loop.
        (async ()=>{
            for(let index = 0; index < concurrency; index++){
                try {
                    // eslint-disable-next-line no-await-in-loop
                    await next();
                } catch (error) {
                    reject(error);
                    break;
                }
                if (isIterableDone || isRejected) break;
            }
        })();
    });
}
function pMapIterable(iterable, mapper, { concurrency = Number.POSITIVE_INFINITY, backpressure = concurrency } = {}) {
    if (iterable[Symbol.iterator] === undefined && iterable[Symbol.asyncIterator] === undefined) throw new TypeError(`Expected \`input\` to be either an \`Iterable\` or \`AsyncIterable\`, got (${typeof iterable})`);
    if (typeof mapper !== "function") throw new TypeError("Mapper function is required");
    if (!(Number.isSafeInteger(concurrency) && concurrency >= 1 || concurrency === Number.POSITIVE_INFINITY)) throw new TypeError(`Expected \`concurrency\` to be an integer from 1 and up or \`Infinity\`, got \`${concurrency}\` (${typeof concurrency})`);
    if (!(Number.isSafeInteger(backpressure) && backpressure >= concurrency || backpressure === Number.POSITIVE_INFINITY)) throw new TypeError(`Expected \`backpressure\` to be an integer from \`concurrency\` (${concurrency}) and up or \`Infinity\`, got \`${backpressure}\` (${typeof backpressure})`);
    return {
        async *[Symbol.asyncIterator] () {
            const iterator = iterable[Symbol.asyncIterator] === undefined ? iterable[Symbol.iterator]() : iterable[Symbol.asyncIterator]();
            const promises = [];
            let runningMappersCount = 0;
            let isDone = false;
            let index = 0;
            function trySpawn() {
                if (isDone || !(runningMappersCount < concurrency && promises.length < backpressure)) return;
                const promise = (async ()=>{
                    const { done, value } = await iterator.next();
                    if (done) return {
                        done: true
                    };
                    runningMappersCount++;
                    // Spawn if still below concurrency and backpressure limit
                    trySpawn();
                    try {
                        const returnValue = await mapper(await value, index++);
                        runningMappersCount--;
                        if (returnValue === pMapSkip) {
                            const index = promises.indexOf(promise);
                            if (index > 0) promises.splice(index, 1);
                        }
                        // Spawn if still below backpressure limit and just dropped below concurrency limit
                        trySpawn();
                        return {
                            done: false,
                            value: returnValue
                        };
                    } catch (error) {
                        isDone = true;
                        return {
                            error
                        };
                    }
                })();
                promises.push(promise);
            }
            trySpawn();
            while(promises.length > 0){
                const { error, done, value } = await promises[0]; // eslint-disable-line no-await-in-loop
                promises.shift();
                if (error) throw error;
                if (done) return;
                // Spawn if just dropped below backpressure limit and below the concurrency limit
                trySpawn();
                if (value === pMapSkip) continue;
                yield value;
            }
        }
    };
}
const pMapSkip = Symbol("skip");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"qayoQ"}],"gF7Lk":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "downloadFile", ()=>downloadFile);
var _pRetry = require("p-retry");
var _pRetryDefault = parcelHelpers.interopDefault(_pRetry);
var _authenticatedFetchJs = require("./authenticated-fetch.js");
var _authenticatedFetchJsDefault = parcelHelpers.interopDefault(_authenticatedFetchJs);
function escapeFilepath(path) {
    return path.replaceAll("%", "%25").replaceAll("#", "%23");
}
async function maybeResponseLfs(response) {
    const length = Number(response.headers.get("content-length"));
    if (length > 128 && length < 140) {
        const contents = await response.clone().text();
        return contents.startsWith("version https://git-lfs.github.com/spec/v1");
    }
    return false;
}
async function fetchPublicFile({ user, repository, reference, file, signal }) {
    const response = await (0, _authenticatedFetchJsDefault.default)(`https://raw.githubusercontent.com/${user}/${repository}/${reference}/${escapeFilepath(file.path)}`, {
        signal
    });
    if (!response.ok) throw new Error(`HTTP ${response.statusText} for ${file.path}`);
    const lfsCompatibleResponse = await maybeResponseLfs(response) ? await (0, _authenticatedFetchJsDefault.default)(`https://media.githubusercontent.com/media/${user}/${repository}/${reference}/${escapeFilepath(file.path)}`, {
        signal
    }) : response;
    if (!response.ok) throw new Error(`HTTP ${response.statusText} for ${file.path}`);
    return lfsCompatibleResponse.blob();
}
async function fetchPrivateFile({ file, signal }) {
    const response = await (0, _authenticatedFetchJsDefault.default)(file.url, {
        signal
    });
    if (!response.ok) throw new Error(`HTTP ${response.statusText} for ${file.path}`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { content } = await response.json();
    const decoder = await fetch(`data:application/octet-stream;base64,${content}`);
    return decoder.blob();
}
async function downloadFile({ user, repository, reference, file, isPrivate, signal }) {
    const fileRequest = {
        user,
        repository,
        reference,
        file,
        signal
    };
    const localDownload = async ()=>isPrivate ? fetchPrivateFile(fileRequest) : fetchPublicFile(fileRequest);
    const onFailedAttempt = (error)=>{
        console.error(`Error downloading ${file.path}. Attempt ${error.attemptNumber}. ${error.retriesLeft} retries left.`);
    };
    return (0, _pRetryDefault.default)(localDownload, {
        onFailedAttempt
    });
}

},{"p-retry":"apmLG","./authenticated-fetch.js":"8PjCA","@parcel/transformer-js/src/esmodule-helpers.js":"qayoQ"}],"apmLG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortError", ()=>AbortError);
parcelHelpers.export(exports, "default", ()=>pRetry);
var _retry = require("retry");
var _retryDefault = parcelHelpers.interopDefault(_retry);
var _isNetworkError = require("is-network-error");
var _isNetworkErrorDefault = parcelHelpers.interopDefault(_isNetworkError);
class AbortError extends Error {
    constructor(message){
        super();
        if (message instanceof Error) {
            this.originalError = message;
            ({ message } = message);
        } else {
            this.originalError = new Error(message);
            this.originalError.stack = this.stack;
        }
        this.name = "AbortError";
        this.message = message;
    }
}
const decorateErrorWithCounts = (error, attemptNumber, options)=>{
    // Minus 1 from attemptNumber because the first attempt does not count as a retry
    const retriesLeft = options.retries - (attemptNumber - 1);
    error.attemptNumber = attemptNumber;
    error.retriesLeft = retriesLeft;
    return error;
};
async function pRetry(input, options) {
    return new Promise((resolve, reject)=>{
        options = {
            onFailedAttempt () {},
            retries: 10,
            shouldRetry: ()=>true,
            ...options
        };
        const operation = (0, _retryDefault.default).operation(options);
        const abortHandler = ()=>{
            operation.stop();
            reject(options.signal?.reason);
        };
        if (options.signal && !options.signal.aborted) options.signal.addEventListener("abort", abortHandler, {
            once: true
        });
        const cleanUp = ()=>{
            options.signal?.removeEventListener("abort", abortHandler);
            operation.stop();
        };
        operation.attempt(async (attemptNumber)=>{
            try {
                const result = await input(attemptNumber);
                cleanUp();
                resolve(result);
            } catch (error) {
                try {
                    if (!(error instanceof Error)) throw new TypeError(`Non-error was thrown: "${error}". You should only throw errors.`);
                    if (error instanceof AbortError) throw error.originalError;
                    if (error instanceof TypeError && !(0, _isNetworkErrorDefault.default)(error)) throw error;
                    decorateErrorWithCounts(error, attemptNumber, options);
                    if (!await options.shouldRetry(error)) {
                        operation.stop();
                        reject(error);
                    }
                    await options.onFailedAttempt(error);
                    if (!operation.retry(error)) throw operation.mainError();
                } catch (finalError) {
                    decorateErrorWithCounts(finalError, attemptNumber, options);
                    cleanUp();
                    reject(finalError);
                }
            }
        });
    });
}

},{"retry":"knQ2X","is-network-error":"lvAqA","@parcel/transformer-js/src/esmodule-helpers.js":"qayoQ"}],"knQ2X":[function(require,module,exports) {
module.exports = require("4f22b206be44b97e");

},{"4f22b206be44b97e":"8e7jM"}],"8e7jM":[function(require,module,exports) {
var RetryOperation = require("a628df618ac3d4");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new RetryOperation(timeouts, {
        forever: options && (options.forever || options.retries === Infinity),
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error("minTimeout is greater than maxTimeout");
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * Math.max(opts.minTimeout, 1) * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === "function") methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

},{"a628df618ac3d4":"63c1u"}],"63c1u":[function(require,module,exports) {
function RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === "boolean") options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    this._timer = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = RetryOperation;
RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts.slice(0);
};
RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    if (this._timer) clearTimeout(this._timer);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.push(err);
        this._errors.unshift(new Error("RetryOperation timeout occurred"));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(0, this._errors.length - 1);
            timeout = this._cachedTimeouts.slice(-1);
        } else return false;
    }
    var self = this;
    this._timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) this._timer.unref();
    return true;
};
RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
RetryOperation.prototype.try = function(fn) {
    console.log("Using RetryOperation.try() is deprecated");
    this.attempt(fn);
};
RetryOperation.prototype.start = function(fn) {
    console.log("Using RetryOperation.start() is deprecated");
    this.attempt(fn);
};
RetryOperation.prototype.start = RetryOperation.prototype.try;
RetryOperation.prototype.errors = function() {
    return this._errors;
};
RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

},{}],"lvAqA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isNetworkError);
const objectToString = Object.prototype.toString;
const isError = (value)=>objectToString.call(value) === "[object Error]";
const errorMessages = new Set([
    "network error",
    "Failed to fetch",
    "NetworkError when attempting to fetch resource.",
    "The Internet connection appears to be offline.",
    "Load failed",
    "Network request failed",
    "fetch failed",
    "terminated"
]);
function isNetworkError(error) {
    const isValid = error && isError(error) && error.name === "TypeError" && typeof error.message === "string";
    if (!isValid) return false;
    // We do an extra check for Safari 17+ as it has a very generic error message.
    // Network errors in Safari have no stack.
    if (error.message === "Load failed") return error.stack === undefined;
    return errorMessages.has(error.message);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"qayoQ"}],"8PjCA":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>authenticatedFetch);
function isGitHubApiUrl(url) {
    try {
        const { hostname, pathname } = new URL(url);
        return hostname === "api.github.com" || pathname.startsWith("/api/v3/");
    } catch  {
        return false;
    }
}
async function authenticatedFetch(url, { signal, method } = {}) {
    const token = globalThis.localStorage?.getItem("token");
    const response = await fetch(url, {
        method,
        signal,
        ...token && isGitHubApiUrl(url) ? {
            headers: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                Authorization: `Bearer ${token}`
            }
        } : {}
    });
    switch(response.status){
        case 401:
            throw new Error("Invalid token");
        case 403:
        case 429:
            // See https://developer.github.com/v3/#rate-limiting
            if (response.headers.get("X-RateLimit-Remaining") === "0") throw new Error("Rate limit exceeded");
            break;
        default:
    }
    return response;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"qayoQ"}],"jufXb":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRepositoryPreview", ()=>getRepositoryPreview);
parcelHelpers.export(exports, "getRepositoryInfo", ()=>getRepositoryInfo);
var _authenticatedFetchJs = require("./authenticated-fetch.js");
var _authenticatedFetchJsDefault = parcelHelpers.interopDefault(_authenticatedFetchJs);
function cleanUrl(url) {
    return url.replace(/[/]{2,}/, "/") // Drop double slashes
    .replace(/[/]$/, ""); // Drop trailing slash
}
function getRepositoryPreview(url) {
    const [, user, repository, ...restPathParts] = cleanUrl(decodeURIComponent(new URL(url).pathname)).split("/");
    const type = restPathParts[0];
    if (!user || !repository) return {
        error: "NOT_A_REPOSITORY"
    };
    if (type && type !== "tree") return {
        error: "NOT_A_DIRECTORY"
    };
    const directoryParts = type === "tree" ? restPathParts.slice(2) : [];
    const parts = type === "tree" ? restPathParts.slice(1) : [];
    return {
        user,
        repository,
        parts,
        directory: directoryParts.join("/")
    };
}
async function parsePath(user, repo, parts) {
    for(let i = 0; i < parts.length; i++){
        const gitReference = parts.slice(0, i + 1).join("/");
        // eslint-disable-next-line no-await-in-loop -- One at a time
        if (await checkBranchExists(user, repo, gitReference)) return {
            gitReference,
            directory: parts.slice(i + 1).join("/")
        };
    }
}
async function getRepositoryInfo(repositoryInfo) {
    const { user, repository, parts } = repositoryInfo;
    const repoInfoResponse = await (0, _authenticatedFetchJsDefault.default)(`https://api.github.com/repos/${user}/${repository}`);
    if (repoInfoResponse.status === 404) return {
        error: "REPOSITORY_NOT_FOUND"
    };
    const { private: isPrivate } = await repoInfoResponse.json();
    if (parts.length === 0) return {
        user,
        repository,
        directory: "",
        isPrivate,
        downloadUrl: `https://api.github.com/repos/${user}/${repository}/zipball`
    };
    if (parts.length === 1) return {
        user,
        repository,
        gitReference: parts[0],
        directory: "",
        isPrivate,
        downloadUrl: `https://api.github.com/repos/${user}/${repository}/zipball/${parts[0]}`
    };
    const parsedPath = await parsePath(user, repository, parts);
    if (!parsedPath) return {
        error: "BRANCH_NOT_FOUND"
    };
    return {
        user,
        repository,
        isPrivate,
        ...parsedPath
    };
}
async function checkBranchExists(user, repo, gitReference) {
    const apiUrl = `https://api.github.com/repos/${user}/${repo}/commits/${gitReference}?per_page=1`;
    const response = await (0, _authenticatedFetchJsDefault.default)(apiUrl, {
        method: "HEAD"
    });
    return response.ok;
}

},{"./authenticated-fetch.js":"8PjCA","@parcel/transformer-js/src/esmodule-helpers.js":"qayoQ"}],"3dq3H":[function(require,module,exports) {
module.exports = require("2fb7a8a63f385dce")(require("5ff594f85ace2a66").resolve("hvOsp")).then(()=>module.bundle.root("eluqN"));

},{"2fb7a8a63f385dce":"6i7Ox","5ff594f85ace2a66":"6oqja"}],"6i7Ox":[function(require,module,exports) {
"use strict";
var cacheLoader = require("ca2a84f7fa4a3bb0");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

},{"ca2a84f7fa4a3bb0":"jQnyX"}],"jQnyX":[function(require,module,exports) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case "preload":
            return cachedPreloads;
        case "prefetch":
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}]},["imzaT","gLO4P"], "gLO4P", "parcelRequire7d3c")

//# sourceMappingURL=index.ea5e85a1.js.map
